import View from '../src/mobile/index';
export default View;
